import { BiTransfer } from "react-icons/bi";
import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary

function OPLOperations() {
  return (
    <>
<div className="service-title font-700 mb-3">OPL <span className="text-orange-ef3e33 font-400 text-uppercase">Operations</span></div>

<div className="row g-3 g-sm-4 g-md-5">
   
    <div className="col-12">
          <p className="mb-4 font-18 font-900">
           ​​Application for OPL launch operation
          </p>
            <p className="mb-4 font-18 font-900">
           REQUIREMENTS:
          </p>
        <p className="font-18 mb-4">
          The Agent shall complete the application form and apply to SAMSA for the Launch Approval by <a href="">clicking here</a> . Agents, using the automated OPL approval system for Algoa Bay for the first time, will be asked to register through the link and to send the registration to SAMSA for approval. The agent will then be able to apply for and obtain automatic OPL launch approvals in Algoa Bay. Each OPL approval shall be deemed to be a separate activity and application shall be made for each ship individually.  Therefore, launch application shall be sent to SAMSA through the system for every launch operation to be undertaken. Post OPL launch information, such as launch times, shall be reported to SAMSA via the automated OPL approval system upon completion of the launch operation.            </p>

         <ul className="trust">
            <li>The electronic application form should include the following information but not limited to:</li>
            <ul className="star-li">
                    <li>Name of the OPL launch operator</li>
                    <li>Name of the receiving vessel
                    </li>
                    <li>Time and date of the launch</li>
                    <li>Reason for the launch</li>
                    <li>Declaration</li>
                    </ul>
            <li>The following documents are to be uploaded onto the automated OPL approval system and submitted along with the application:
                <ul className="star-li">
                    <li>P&I cert                    
                    </li>
                    <li>WRC                        
                    </li>
                    <li>Safety Construction Certificate                      
                    </li>
                    </ul>

            </li>
            <li>
                The agent shall capture the dates of each documents referred to above and declare their validity on the system.
            </li>
        </ul>
          <p className="mb-4 font-18 font-900">
           RESTRICTIONS:
          </p>
          <ul class="green-star-ul">
            <li>OPL operation may not be done at the same time as STS operation.
            </li>
            <li>No transfer of crew / or personnel, including bunker surveyor(s) is permitted during the hours of darkness
             </li>
            <li>If any lube oils are to be transported or transhipped, the approval must be sought from the office of the Harbour Master and a copy of the approval must be sent to SAMSA. An approved spill contractor must be on standby until the lube oils are safely loaded on-board the receiving vessel. Only properly sealed drums, with screw down tops are to be transported.               
            </li>
            </ul>

        <p className="mb-4 font-18 font-900"><a href="">Licenced OPL Boat Operators in Algoa Bay</a> 
            </p>
       

    </div>
    
</div>
    </>
  );
}

export default OPLOperations;
